export enum RoomDisplayResult {
  InProgress = 'IN_PROGRESS',
  Win = 'WIN',
  Lose = 'LOSE',
  Draw = 'DRAW',
  Cancelled = 'CANCELLED',
}
